import React from 'react';

/**
 * ErrorBoundary
 *
 * Wrap route trees or individual pages to catch render errors gracefully.
 *
 * Usage:
 *   <ErrorBoundary>
 *     <SomePageComponent />
 *   </ErrorBoundary>
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // You could send to a logging service here
    console.error('[ErrorBoundary]', error, info.componentStack);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        padding: 32,
        textAlign: 'center',
        color: '#e2e8f0',
        fontFamily: 'system-ui, sans-serif',
      }}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>💥</div>
        <h2 style={{ margin: '0 0 8px', fontSize: 22 }}>Something went wrong</h2>
        <p style={{ color: '#94a3b8', maxWidth: 420, lineHeight: 1.6, margin: '0 0 24px' }}>
          An unexpected error occurred. You can try refreshing the page or going back.
        </p>
        {process.env.NODE_ENV === 'development' && this.state.error && (
          <pre style={{
            background: '#0f172a', border: '1px solid #1e293b', borderRadius: 8,
            padding: '12px 16px', fontSize: 12, color: '#f87171',
            maxWidth: 600, width: '100%', textAlign: 'left',
            overflow: 'auto', marginBottom: 24,
          }}>
            {this.state.error.toString()}
          </pre>
        )}
        <div style={{ display: 'flex', gap: 12 }}>
          <button
            onClick={this.handleReset}
            style={{
              padding: '10px 22px', borderRadius: 8, border: 'none',
              background: '#6c63ff', color: '#fff', fontWeight: 600,
              fontSize: 14, cursor: 'pointer',
            }}
          >
            Try again
          </button>
          <button
            onClick={() => window.location.href = '/'}
            style={{
              padding: '10px 22px', borderRadius: 8,
              border: '1px solid #334155', background: 'transparent',
              color: '#94a3b8', fontWeight: 600, fontSize: 14, cursor: 'pointer',
            }}
          >
            Go home
          </button>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
